// extracted by mini-css-extract-plugin
module.exports = {"no_bm":"Compare_no_bm__1LH3p"};